require("./components/bootstrap");
import mixin from "./components/mixin.js";
var app = new Vue({
    el: '#app',
    mixins: [mixin],
    data: {
        phone: null,
        eventNo: null,
        submiting: false,
    },
    computed: {},
    created() {},
    methods: {
        async validateCheckOrder() {
            if (this.submiting) {
                return;
            }
            try {
                this.submiting = true;
                const {
                    data
                } = await axios
                    .post("/order/checkSubmit", {
                        lang: this.lang,
                        checkPhone: this.phone,
                        eventNo: this.eventNo,
                    });
                if (data.result == 200) {
                    location.href = data.url;
                } else if (typeof data.errors != 'undefined') {
                    var errMessage = '';
                    if (typeof data.errors.eventNo != 'undefined') {
                        errMessage += data.errors.eventNo + '<br />';
                    }
                    if (typeof data.errors.checkPhone != 'undefined') {
                        errMessage += data.errors.checkPhone + '<br />';
                    }
                    // update showAlert function
                    this.showAlert(message.title, errMessage);
                } else {
                    if (data.title && data.message) {
                        this.showAlert(data.title, data.message);
                    } else {
                        this.showAlert(message.title, message.content);
                    }
                }
                this.submiting = false;
            } catch (e) {
                console.log(e);
                this.submiting = false;
                this.showAlert(message.title, message.content);
            }
        },
    }
})
